var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block" },
    [
      _c("el-date-picker", {
        attrs: {
          type: "daterange",
          "range-separator": "~",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          "picker-options": _vm.pickerOptions,
        },
        on: { change: _vm.handclickdate },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }